import React, { useState } from "react";
import axios from 'axios';
import * as API from "../../Endpoints/Endpoints";
import { useNavigate } from 'react-router-dom';

const CardGroup = () => {
  const [formData, setFormData] = useState({
    grpname: "",
    gamename: "",
    gamecategory: "",
    gamechallenges: "",
  });
  const [file, setFile] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]); // Store the selected file
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataObj = new FormData();

    // Append form data
    Object.entries(formData).forEach(([key, value]) => {
      formDataObj.append(key, value);
    });

    // Append file
    if (file) {
      formDataObj.append('grpsymbol', file); // Add the image file
    }

    try {
      const response = await axios.post(API.POST_CARDGROUP_API, formDataObj, {
        headers: {
          'Content-Type': 'multipart/form-data', // Set multipart header
        },
      });

      if (response.status === 201) {
        console.log("Form Data Submitted Successfully:", response.data);
        setFormData({
          grpname: "",
          gamename: "",
          gamecategory: "",
          gamechallenges: "",
        });
        setFile(null);
        alert("Data submitted successfully!");
        navigate('/cardgrouptable');
      } else {
        alert("Failed to submit data.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting data.");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-700 mb-6">
          Card Group
        </h2>
        <form onSubmit={handleSubmit}>
          {/* Group Name */}
          <div className="mb-4">
            <label
              htmlFor="grpname"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Group Name
            </label>
            <input
              type="text"
              id="grpname"
              name="grpname"
              value={formData.grpname}
              onChange={handleChange}
              placeholder="Enter group name"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>

          {/* Group Symbol */}
          <div className="mb-4">
            <label
              htmlFor="grpsymbol"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Group Symbol
            </label>
            <input
              type="file"
              id="grpsymbol"
              onChange={handleFileChange}
              accept="image/*"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>

          {/* Game Name */}
          <div className="mb-4">
            <label
              htmlFor="gamename"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Game Name
            </label>
            <input
              type="text"
              id="gamename"
              name="gamename"
              value={formData.gamename}
              onChange={handleChange}
              placeholder="Enter game name"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>

          {/* Game Category */}
          <div className="mb-4">
            <label
              htmlFor="gamecategory"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Game Category
            </label>
            <input
              type="text"
              id="gamecategory"
              name="gamecategory"
              value={formData.gamecategory}
              onChange={handleChange}
              placeholder="Enter game category"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>

          {/* Game Challenges */}
          <div className="mb-4">
            <label
              htmlFor="gamechallenges"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Game Challenges
            </label>
            <textarea
              id="gamechallenges"
              name="gamechallenges"
              value={formData.gamechallenges}
              onChange={handleChange}
              placeholder="Describe game challenges"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              rows="4"
              required
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full bg-[#e64a32] text-white py-2 px-4 rounded-lg hover:bg-[#e64a32] focus:outline-none"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default CardGroup;
